export default [
  {
    path: '/admin-dashboard',
    name: 'admin_dashboard',
    component: () => import('@/views/modules/skeleton/admin/Dashboard.vue'),
    meta: {
      title: 'Dashboard',
      icon: 'HomeIcon',
      navActive: true,
      breadcrumb: [
        {
          text: 'Dashboard',
          active: true,
          back: true,
        },
      ],
    },
  },
  {
    path: '/users/:institution_id?',
    name: 'users',
    component: () => import('@/views/modules/skeleton/admin/Users.vue'),
    meta: {
      title: 'Users',
      icon: 'UserIcon',
      navActive: true,
      breadcrumb: [
        {
          text: 'Users',
          active: true,
          // back: true,
        },
      ],
    },
  },
]
